import { queryOptions } from '@tanstack/react-query';

import { SuccessResponse } from 'src/apis/dto/common';
import { DTOProfileInputPopupsResponse } from 'src/apis/dto/DTOProfileInputPopups';
import { useRestMutation } from 'src/hooks/useRestMutation';
import { RestQueryOptions, useRestQuery } from 'src/hooks/useRestQuery';
import { client } from 'src/utils/api';

import {
  AzarToCheeroGuideRequest,
  AzarToCheeroGuideResponse,
  DeletionGuidelineResponse,
  NoticePopupResponse,
  ReportPopupViewedRequest,
} from './types';

export enum PopupApiList {
  /**
   * 특정 유형의 팝업을 확인했을 때 이를 서버에 공유하는 API
   */
  ReportPopupViewed = '/api/popups/viewed/',
  NoticePopup = '/api/popups/notice/',
  DeletionGuideline = '/api/popups/deletion-guidelines/',
  AzarToCheeroGuide = '/api/popups/azar-to-cheero-guide',
  ProfileInputPopups = '/api/popups/profile-inputs',
}

export const useReportPopupViewedMutation = () => {
  return useRestMutation<ReportPopupViewedRequest>({
    method: 'post',
    path: PopupApiList.ReportPopupViewed,
  });
};

export const useNoticePopupQuery = () => {
  return useRestQuery<void, NoticePopupResponse, void>({
    path: PopupApiList.NoticePopup,
  });
};

export const useDeletionGuidelineQueryOptions = () => {
  return queryOptions({
    queryKey: [PopupApiList.DeletionGuideline],
    async queryFn() {
      const response = await client.get<SuccessResponse<DeletionGuidelineResponse>>(
        PopupApiList.DeletionGuideline
      );
      return response.data.result;
    },
  });
};

export const useAzarToCheeroGuideQuery = (countryCode: AzarToCheeroGuideRequest['countryCode']) => {
  return useRestQuery<AzarToCheeroGuideRequest, AzarToCheeroGuideResponse, void>({
    path: PopupApiList.AzarToCheeroGuide,
    params: { countryCode },
    withoutAuth: true,
  });
};

export const useProfileInputPopupsQuery = (
  options: RestQueryOptions<DTOProfileInputPopupsResponse, void> = {}
) => {
  return useRestQuery<void, DTOProfileInputPopupsResponse, void>({
    path: PopupApiList.ProfileInputPopups,
    options,
  });
};
